import { createFileRoute } from "@tanstack/react-router";
import useFonts from "@/components/Fonts/useFonts";
import Wizard from "@/components/Wizard";

export const Route = createFileRoute("/$organizationKey/$dossierId/$researchProjectId/wizard")({
  component: WizardPage,
});

function WizardPage() {
  const { researchProjectId } = Route.useParams();
  useFonts();
  return <Wizard researchProjectId={Number.parseInt(researchProjectId)} />;
}
